import { render, staticRenderFns } from "./setLowCode.vue?vue&type=template&id=c63787e8&scoped=true&lang=pug"
import script from "./setLowCode.vue?vue&type=script&lang=js"
export * from "./setLowCode.vue?vue&type=script&lang=js"
import style0 from "./setLowCode.vue?vue&type=style&index=0&id=c63787e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63787e8",
  null
  
)

export default component.exports